import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/6975efbc1beda800146ff032/ai_change_leaders/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6975efbc1beda800146ff032/ai_change_leaders/src/components/common/Header.tsx");
